module.exports = __webpack_public_path__ + "static/media/bg-3.ba244202.png";